<div class="eye-panel eye-color-alt">
  <div class="eye-panel__inner container">
    <div class="eye-panel__item eye-panel-item">
      <p class="eye-panel-item__title">{{ 'FONT_SIZE' | translate }}:</p>
      <div class="eye-panel-item__actions">
        @for (level of fontSizeLevels; track level; let i = $index) {
          <button
            class="eye-panel-button font-weight-bold eye-hover-alt"
            [ngClass]="'eye-fz-' + level"
            [class.eye-active-alt]="level === currentFontSizeLevel"
            type="button"
            [title]="fontSizeTitles[i]"
            (click)="changeFontSize(level)"
          >
            А
          </button>
        }
      </div>
    </div>

    <div class="eye-panel__item">
      <div class="eye-panel-buttons">
        <button
          class="eye-panel-button-primary eye-color-alt eye-hover-alt"
          type="button"
          (click)="showSetting = !showSetting"
        >
          <fa-icon [icon]="faCog" transform="down-1"></fa-icon>
          {{ 'SETTINGS' | translate }}
          <fa-icon
            [icon]="faChevronDown"
            [rotate]="showSetting ? '180' : '0'"
            transform="shrink-3 down-1"
          ></fa-icon>
        </button>
        <button
          class="eye-panel-button-primary eye-color-alt eye-hover-alt"
          type="button"
          (click)="eyeService.disable()"
        >
          <fa-icon [icon]="faEyeSlash" transform="down-1"></fa-icon>
          {{ 'EYE_SIGHT_OFF' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

@if (showSetting) {
  <div class="eye-panel-settings eye-color" @panel>
    <div class="container">
      <div class="eye-panel-settings__inner">
        <div class="eye-panel-setting">
          <h2 class="eye-panel-setting__title">
            {{ 'COLOR_SCHEME' | translate }}:
          </h2>
          <ul class="eye-panel-setting__list">
            <li>
              <button
                class="eye-panel-setting__button eye-hover color-scheme-button black-on-white"
                [class.eye-active]="currentColorMode === ColorMode.blackOnWhite"
                type="button"
                [title]="'BLACK_ON_WHITE' | translate"
                (click)="changeColorMode(ColorMode.blackOnWhite)"
              >
                Щ
              </button>
              <button
                class="eye-panel-setting__button eye-hover color-scheme-button white-on-black"
                [class.eye-active]="currentColorMode === ColorMode.whiteOnBlack"
                type="button"
                [title]="'WHITE_ON_BLACK' | translate"
                (click)="changeColorMode(ColorMode.whiteOnBlack)"
              >
                Щ
              </button>
              <button
                class="eye-panel-setting__button eye-hover color-scheme-button navy-on-blue"
                [class.eye-active]="currentColorMode === ColorMode.navyOnBlue"
                type="button"
                [title]="'NAVY_ON_BLUE' | translate"
                (click)="changeColorMode(ColorMode.navyOnBlue)"
              >
                Щ
              </button>
              <button
                class="eye-panel-setting__button eye-hover color-scheme-button green-on-brown"
                [class.eye-active]="currentColorMode === ColorMode.greenOnBrown"
                type="button"
                [title]="'GREEN_ON_BROWM' | translate"
                (click)="changeColorMode(ColorMode.greenOnBrown)"
              >
                Щ
              </button>
            </li>
          </ul>
        </div>
        <div class="eye-panel-setting">
          <h2 class="eye-panel-setting__title">
            {{ 'TEXT_SETTINGS' | translate }}:
          </h2>
          <ul class="eye-panel-setting__list">
            <li>
              <p class="eye-panel-setting__list-title">
                {{ 'FONT_STYLE' | translate }}
              </p>
              <button
                class="eye-panel-setting__button eye-hover"
                [class.eye-active]="currentFontType === FontTypes.sansSerif"
                type="button"
                (click)="changeFontType(FontTypes.sansSerif)"
              >
                {{ 'SANS_SERIF' | translate }}
              </button>
              <button
                class="eye-panel-setting__button eye-hover"
                [class.eye-active]="currentFontType === FontTypes.serif"
                type="button"
                (click)="changeFontType(FontTypes.serif)"
              >
                {{ 'SERIF' | translate }}
              </button>
            </li>
            <li>
              <p class="eye-panel-setting__list-title">
                {{ 'LETTER_SPACING' | translate }}
              </p>
              <button
                class="eye-panel-setting__button eye-hover"
                [class.eye-active]="
                  currentFontInterval === FontIntervals.standard
                "
                type="button"
                (click)="changeFontInterval(FontIntervals.standard)"
              >
                {{ 'STANDARD' | translate }}
              </button>
              <button
                class="eye-panel-setting__button eye-hover"
                [class.eye-active]="
                  currentFontInterval === FontIntervals.medium
                "
                type="button"
                (click)="changeFontInterval(FontIntervals.medium)"
              >
                {{ 'MEDIUM' | translate }}
              </button>
              <button
                class="eye-panel-setting__button eye-hover"
                [class.eye-active]="currentFontInterval === FontIntervals.large"
                type="button"
                (click)="changeFontInterval(FontIntervals.large)"
              >
                {{ 'LARGE' | translate }}
              </button>
            </li>
          </ul>
        </div>
        <div class="eye-panel-setting">
          <h2 class="eye-panel-setting__title">{{ 'GRAPHIC' | translate }}:</h2>
          <ul class="eye-panel-setting__list">
            <li>
              <p class="eye-panel-setting__list-title">
                {{ 'IMAGES' | translate }}
              </p>
              <button
                class="eye-panel-setting__button eye-hover"
                [class.eye-active]="currentGraphicMode === GraphicMode.disabled"
                type="button"
                (click)="changeGraphicMode(GraphicMode.disabled)"
              >
                {{ 'OFF' | translate }}
              </button>
              <button
                class="eye-panel-setting__button eye-hover"
                [class.eye-active]="currentGraphicMode === GraphicMode.enabled"
                type="button"
                (click)="changeGraphicMode(GraphicMode.enabled)"
              >
                {{ 'FULL_COLOR' | translate }}
              </button>
              <button
                class="eye-panel-setting__button eye-hover"
                [class.eye-active]="
                  currentGraphicMode === GraphicMode.monochrome
                "
                type="button"
                (click)="changeGraphicMode(GraphicMode.monochrome)"
              >
                {{ 'MONOCHROME' | translate }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="eye-panel-footer eye-color-alt">
      <div class="container">
        <div class="eye-panel-footer__inner">
          <button
            class="eye-panel-button-primary eye-hover-alt"
            type="button"
            (click)="setDefaults()"
          >
            <fa-icon [icon]="faUndo" transform="down-1"></fa-icon>
            {{ 'RETURN_STANDARD_SETTINGS' | translate }}
          </button>
          <button
            class="eye-panel-button-primary eye-hover-alt"
            type="button"
            (click)="scrollToContent()"
          >
            <fa-icon [icon]="faNewspaper" transform="down-1"></fa-icon>
            {{ 'CONTENT' | translate }}
          </button>
          <button
            class="eye-panel-button-primary eye-hover-alt"
            type="button"
            (click)="showSetting = false"
          >
            <fa-icon [icon]="faTimes" transform="down-1"></fa-icon>
            {{ 'CLOSE' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
}
